var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chat-log',{ref:"chatLog",attrs:{"serviceIcons":_vm.serviceIcons,"channels":_vm.channels}})
}
var staticRenderFns = []

export { render, staticRenderFns }